
//import TextLink from '@/components/elements/TextLink.vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'

export default {
  name: 'EventPresent',
  components: { HeadingLv2 },
  setup() {
    //
  }
}
